var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAtminline = function SvgAtminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "atm_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "3 0 50 50"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".atm_inline_svg__st1{fill:#00a98f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_902_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_907_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_911_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_1748_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_913_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_914_",
    d: "M12 14.5v22h26v-22H12zm24 20H14v-18h22v18z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_912_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_916_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_917_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_918_",
    d: "M29.9 24c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.3 0 .7.3.7.7z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_920_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_921_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_922_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_923_",
    d: "M29.9 26.2c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.3 0 .7.3.7.7z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_925_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_926_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_927_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_928_",
    d: "M32 24c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.4 0 .7.3.7.7z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_930_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_931_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_932_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_933_",
    d: "M29.9 21.8c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.3 0 .7.3.7.7z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_935_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_936_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_937_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_938_",
    d: "M32 21.8c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.4 0 .7.3.7.7z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_940_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_941_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_942_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_943_",
    d: "M32 26.2c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.4 0 .7.3.7.7z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_945_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_946_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_947_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_948_",
    d: "M34.2 24c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.4 0 .7.3.7.7z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_950_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_951_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_952_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_953_",
    d: "M34.2 21.8c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.4 0 .7.3.7.7z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_955_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_956_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_957_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_958_",
    d: "M34.2 26.2c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.4 0 .7.3.7.7z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_960_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_1747_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_962_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_963_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_964_",
    d: "M15.9 29.7h10.9v1H15.9z",
    className: "atm_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_961_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_1746_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_966_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_967_",
    d: "M15.9 31.6h10.9v1H15.9z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_965_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_1735_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_970_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_971_",
    d: "M34.1 30.1h-5.5l-.8 2.7h7.1l-.8-2.7zm-5 1.7.2-.7h4l.2.7h-4.4z",
    className: "atm_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_3126_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_inline_svg__XMLID_973_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "atm_inline_svg__XMLID_974_",
    d: "M15.6 19v9h11v-9h-11zm1.8 4.5c-.1 0-.3-.1-.4-.1-.2-.2-.2-.5 0-.7l2.3-2.3c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-2.3 2.3s-.1.1-.3.1zm4.8-2.1L20.6 23c-.1.1-.2.2-.3.2-.1 0-.3-.1-.4-.2-.2-.2-.2-.5 0-.7l1.6-1.6c.2-.2.5-.2.7 0 .2.2.2.5 0 .7z",
    className: "atm_inline_svg__st1"
  })))))));
};
export default SvgAtminline;